import React from "react";
import {KNavbar, KNavBrandFixed} from "@kopjra/uikit";

export interface StateProps {
    locale: string;
}

export interface DispatchProps {
    onChangeLocale: (locale: string) => void;
    onGoHome: () => void;
    onGoAccount: () => void;
}

export interface InnerProps {
}

export type Props = StateProps & DispatchProps & InnerProps;

export const Toolbar: React.FC<Props> = ({locale, onChangeLocale, onGoHome, onGoAccount}) => {
    // const {isAuthenticated, loginWithRedirect, logout} = useAuth0();
    // const {location} = useRouter();
    return (
        <KNavbar
            brand={<KNavBrandFixed iconPartial="kopjra" appName="Estimator"/>}
            // rightMost={
            //     <KNavLangSelector  onChangeLocale={(loc) => onChangeLocale(loc)} locale={locale} translations={translations} alignRight={true}/>
            // }
        >
            {/*<KNavLink active={location.pathname === Routes.HOME} onClick={() => onGoHome()} element={<Translate value="menu.home"/>}/>*/}
            {/*<KNavDropdown id={"user.profile-dropdown"} title={<Translate value="user.account"/>}>*/}
            {/*    {!isAuthenticated ? (*/}
            {/*        <>*/}
            {/*            <div style={{padding: 20, width: "100%"}}>*/}
            {/*                <KButton text={<span><i className="fal fag fa-sign-in"/> <Translate value="user.login"/></span>} variant={KBUTTON_VARIANT.success} size={KBUTTON_SIZE.sm}*/}
            {/*                         onClick={() => loginWithRedirect()} fill={true}/>*/}
            {/*            </div>*/}
            {/*            <KNavDropdownItem onClick={() => noop()}>*/}
            {/*                <Translate value="user.support"/>*/}
            {/*            </KNavDropdownItem>*/}
            {/*         </>*/}
            {/*    ) : (*/}
            {/*        <>*/}
            {/*            <KNavDropdownItem onClick={() => onGoAccount()}>*/}
            {/*                <Translate value="user.profile"/>*/}
            {/*            </KNavDropdownItem>*/}
            {/*            <KNavDropdownItem onClick={() => noop()}>*/}
            {/*                <Translate value="user.support"/>*/}
            {/*            </KNavDropdownItem>*/}
            {/*            <KNavDropdownItem onClick={() => logout({returnTo: window.location.origin})}>*/}
            {/*                <Translate value="user.logout"/>*/}
            {/*            </KNavDropdownItem>*/}
            {/*        </>*/}
            {/*    )}*/}
            {/*</KNavDropdown>*/}
        </KNavbar>
    );
}